var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#202E35",
    strokeWidth: 1.5,
    d: "M31.25 16c0 8.422-6.828 15.25-15.25 15.25S.75 24.422.75 16 7.578.75 16 .75 31.25 7.578 31.25 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#202E35",
    d: "M14.368 21.333l.823-.802-4.423-4.318h12.936v-1.137H10.768l4.423-4.318-.822-.802-5.835 5.689 5.834 5.688z"
  })));
}
export default SvgArrowBack;